import { Divider, Group, ScrollArea, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { FilterItem } from '../../../../components/filters/filter-item';
import { ResetFiltersButton } from '../../../../components/filters/reset-filters-button';
import { SmallSquareButton } from '../../../../components/small-square-button/small-square-button';
import { useFinancialsStore } from '../../../../store/financials-store/financials-store';
import {
  resetCostVersusOutputFilters,
  toggleCostVersusOutputMeasure,
  toggleCostVersusOutputTrendLine,
} from '../../../../store/financials-store/financials-store.actions';
import type { CostVersusOutputMeasures } from '../../../../store/financials-store/financials-store.type';
import { Text } from '../../../../ui-library/typography/typography';
import {
  COST_VERSUS_OUTPUT_MEASURES,
  INITIAL_COST_VERSUS_OUTPUT_MEASURES,
  MAX_SELECTED_FILTERS,
} from '../../constants';
import { getMeasureName } from './cost-versus-output.helpers';

interface FiltersProps {
  setShow: (show: boolean) => void;
}

function Filters({ setShow }: FiltersProps) {
  const i18n = useTranslation();
  const {
    filters: { costVersusOutput },
  } = useFinancialsStore();

  return (
    <Stack h="100%" style={{ position: 'relative' }}>
      <Group justify="space-between">
        <Text size="medium" weight="medium">
          {i18n.t('common.filters')}
        </Text>
        <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" />
      </Group>
      <Divider />
      <ScrollArea h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <Stack pb={40}>
          <Group justify="space-between">
            <Text size="small" weight="bold">
              {i18n.t('common.measures')}
            </Text>
            <Text size="small" weight="bold">
              {i18n.t('process_analysis.filters.trends')}
            </Text>
          </Group>
          {COST_VERSUS_OUTPUT_MEASURES.map((measure) => {
            return (
              <FilterItem
                key={measure}
                value={measure}
                label={getMeasureName(measure, i18n.t)}
                isSelected={costVersusOutput.selectedMeasures.includes(measure)}
                isSelectedTrends={costVersusOutput.selectedTrendLines.includes(measure)}
                showTrends={true}
                selectedCount={costVersusOutput.selectedMeasures.length}
                maxSelected={MAX_SELECTED_FILTERS}
                onToggle={(value) => toggleCostVersusOutputMeasure(value as CostVersusOutputMeasures)}
                onTrendsToggle={(value) => toggleCostVersusOutputTrendLine(value as CostVersusOutputMeasures)}
              />
            );
          })}
          <Divider />
        </Stack>
      </ScrollArea>
      <ResetFiltersButton
        onClick={() => resetCostVersusOutputFilters()}
        visible={
          JSON.stringify(costVersusOutput.selectedMeasures) !== JSON.stringify(INITIAL_COST_VERSUS_OUTPUT_MEASURES) ||
          costVersusOutput.selectedTrendLines.length > 0
        }
      />
    </Stack>
  );
}

export { Filters };
